import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { ROUTES, TEST_ID, CONTACT_EMAIL } from "../../../../helpers/constants";
import CompetencyModeSelector, {
  COMPETENCY_MODE,
  isCompetencySelectionValid,
  selectedCompetencesForPayload,
} from "./competency-mode-selector";
import { useNavigate } from "react-router-dom";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { useSkillsAction } from "../../../../services/actions/skills.action";
import { useRecoilValue } from "recoil";
import ColorsCircles from "../../params/components/colors-roles";
import { HiCheck, HiOutlineCloudUpload, HiOutlinePlusCircle, HiPlus } from "react-icons/hi";
import { useChargesAction } from "../../../../services/actions/charges.action";
import { userAtom } from "../../../../services/atoms/auth.atoms";
import toast, { Toaster } from "react-hot-toast";
import { chargesAtom, crudChargesAtom } from "../../../../services/atoms/charges.atoms";
import { statusColors, statusTranslator } from "../../../../helpers/functions";
import moment from "moment";
import { useCollaboratorsActions } from "../../../../services/actions/collaborators.actions";
import { useSelectionProcessAction } from "../../../../services/actions/selection-process.actions";
import AddCollaboratorModal from "./add-collaborator-modal";
import BulkLoadModal from "../../clients-details/components/bulk-load-modal";
import CreateCollaboratorModal from "../../collaborator-details/components/create-modal";
import BulkLoadErrors from "../../clients-details/components/bulk-load-modal-errors";
import { InputIcon } from "../../../../components/inputs/input-icon";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { AiOutlineClose } from "react-icons/ai";
import TableComponent from "../../../../components/table/table-component";
import InfoCharge from "../../params/components/info-charge";

const badgeAccessor = (row) => (
  <div
    className={`gm-badge gm-badge--${statusColors(
      row.length === 0 ? 0 : row[0]?.statusId 
    )}`}
  >
    <span>
      {row.length === 0
        ? statusTranslator(0) 
        : statusTranslator(row[0]?.statusId)}
    </span>
  </div>
);
const dateFotmatter = (date) => (
  <div>
    
    {date[0]?.finishedAt
      ? `${moment(date[0]?.finishedAt).format("DD-MM-YYYY HH:mm")} hrs`
      : "--/--/----"}
  </div>
);

const columns = [
  {
    Header: "Nombre",
    accessor: ({ name, surname }) => (
      <div>
        {name} {surname}
      </div>
    ),
    disableSortBy: true,
  },
  {
    Header: "Estado",
    accessor: ({ latestTest }) => badgeAccessor(latestTest),
    disableSortBy: true,
  },
  {
    Header: " % Match",
    accessor: ({ latestTest }) => <div>-</div>,
  },
  {
    Header: "Realizado el",
    accessor: ({ latestTest }) => dateFotmatter(latestTest),
  },
  {
    Header: "Origen",
    accessor: ({ collaboratorInternal }) => (
      <div>{collaboratorInternal ? "Interno" : "Externo"}</div>
    ),
    disableSortBy: true,
  },
];

const initialSearchValue = { name: "", position: "" };

const stepProcessCreate = [
  { step: 1, name: "CARGO" },
  { step: 2, name: "COMPETENCIAS" },
  { step: 3, name: "EVALUACIÓN" },
  { step: 4, name: "VISUALIZAR" },
];

const initialChargeValues = {
  id: "",
  name: "",
  type: "",
  currentClientsId: "",
  description: "",
  competences: [],
};

const testData = ["Test DISC + motivadores"];

const initialSetOpenState = {
  editCharge: false,
  createCollab: false,
  bulk: false,
  errors: false,
  invitation: false,
};


const CreateProcessSelectionAndCharge = (props) => {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom)
  const chargeResolver = useRecoilValue(crudChargesAtom)
  const { listSkills } = useSkillsAction();
  const {createCharge, listCharges}=useChargesAction()
  const {createProcessSelection } =useSelectionProcessAction()
  const {sendInvitation, listCollaborator} = useCollaboratorsActions()
  const [stepsPass, setSteps] = useState(1);
  const [charge, setCharge] = useState(initialChargeValues);
  const [idCharge, setIdCharge] = useState("");
  const [skillList, setListSkills] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedColor, setSelectedColor] = useState('azul')
  const [chargeCreated, setChargeCreated] = useState(false)
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);
  const [createProcess, setCreateProcess] = useState(false);
  const [charges, setCharges] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState(initialChargeValues);
  const [collaborators, setCollaborators] = useState([]);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const [selectedTest, setSelectedTest] = useState([]);
  const [competencyMode, setCompetencyMode] = useState(COMPETENCY_MODE.PATTERN);
  const [selectedCompetences, setSelectedCompetences] = useState([]);
  const [open, setOpen] = useState(initialSetOpenState);
  const [errorsModal, setErrorsModal] = useState([]);
  const [showCollaborators, setShowCollaborators] = useState(false);
  const [filteredCollaborators, setFilteredCollaborators] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [updatedCollaborators, setUpdatedCollaborator] = useState(false);
  const [rutNewCollab, setRutNewCollab] = useState("");
  const [createdProcess, setCreatedProcess] = useState(false)
  const [filteredTableCollaborators, setFilteredTableCollaborators] = useState(
    []
  );



  const handleCancelProcess = () => {
    navigate(ROUTES.PROCESS.route);
  };

  const handleChange = (key, value) =>
    setCharge((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSelectColor = (event) => {
    event.preventDefault();
    setSelectedColor(event.target.value)
    setFilteredSkills(
      skillList.filter((skills) =>
        skills.colorType.includes(event.target.value)
      )
    );
  };


  const handleCreateCharge = (e) => {
    const idNew = uuidv4();
    const competencesId = selectedSkills.map((selected)=>selected.id)
    const data = { ...charge, id: idNew, competences: competencesId, currentClientsId: user?.data?.clientId};

    createCharge(data, ()=>{
    setIdCharge(idNew);
      toast.success('Cargo creado éxitosamente', {duration:4000})
      setChargeCreated(true)
      setSteps(stepsPass + 1);
      getCharges()
    })
  };
  
  const handleSelectSkill = (skill) => {
    if (!selectedSkills.find((selected) => selected.id === skill.id)) {
      setSelectedSkills((prevValues) => [...prevValues, skill]);
    } else {
      setSelectedSkills(selectedSkills.filter((selected) => selected.id !== skill.id))
    }
  };

  const handleSelect = (key, event) => {
    event.preventDefault();
    if (key === "test") {
      setSelectedTest(event.target.value);
    }
  };
  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setShowCollaborators(false);
    }
  };

const getCharges = async () => {
  const response = await listCharges({
    currentClientsId: user?.data?.clientId,
  });
  setCharges(response?.data);
};


const handleOpenModal = (key) =>
  setOpen((modal) => ({ ...modal, [key]: !modal[key] }));

const getCollaborators = async () => {
  const response = await listCollaborator({ clientId: user?.data?.clientId });
  if(response?.data === 0){
    setCollaborators([])
  } else {
    setCollaborators(response?.data) 
  }
};

const handleDeleteCollaborator = (id) => {
  setSelectedCollaborators(
    selectedCollaborators.filter((collab) => collab.id !== id)
  );
};

const handleSelectAllCollaborators = (e) => {
  if (e.target.checked) {
    setSelectedCollaborators([...collaborators]);
  } else {
    setSelectedCollaborators([]);
  }
};

const isCollaboratorSelected = (id) => {
  return selectedCollaborators.some((collab) => collab.id === id);
};

const handleSelectCollaborator = (id) => {
  const selectedCollab = collaborators.find((collab) => collab.id === id);
  if (selectedCollab) {
    if (isCollaboratorSelected(id)) {
      setSelectedCollaborators(
        selectedCollaborators.filter((collab) => collab.id !== id)
      );
    } else {
      setSelectedCollaborators((prevValues) => [
        ...prevValues,
        selectedCollab,
      ]);
    }
  }
};
const resetSelect = () => {
  const select = document.querySelector('select[name="origen"]');
  select.selectedIndex = 0;
};

const handleChangeValue = (key, value) =>
  setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

const handleSearchByName = (event) => {
  event.preventDefault();
  setFilteredTableCollaborators(selectedCollaborators);
  setSearch(event);
  setIsFiltered(true);
  setFilteredTableCollaborators(
    selectedCollaborators.filter((collab) =>
      collab.name.toLowerCase().includes(searchValues.name.toLowerCase())
    )
  );
};

const handleChangeOrigin = (event) => {
  event.preventDefault();
  const selectedValue = event.target.value;
  if (selectedValue !== "false") {
    const origin = event.target.value;
    setFilteredTableCollaborators(selectedCollaborators);
    setSearch(origin);
    setIsFiltered(true);
    setFilteredTableCollaborators(
      selectedCollaborators.filter((collab) =>
        origin === "collaboratorInternal"
          ? collab.collaboratorInternal
          : collab.collaboratorExternal
      )
    );
  } else {
    return;
  }
};
const handleCleanSearch = () => {
  setFilteredTableCollaborators(selectedCollaborators);
  setSearch("");
  setSearchValue(initialSearchValue);
  resetSelect();
  setIsFiltered(false);
};

const handleSubmit = async () => {
  setCreatedProcess(true)
  const idCollaborators = selectedCollaborators.map((collab) => collab.id);
  const idProcess = uuidv4();
  const data = {
    id: idProcess,
    clientId: user?.data.clientId || "",
    positionId: idCharge,
    collaborator: idCollaborators,
  };
  await createProcessSelection(data, (res) => {
    if(res.status === 200){
      sendInvitation(
        {
          testID: `${TEST_ID}`,
          collaboratorIDs: idCollaborators,
          selectedCompetences: selectedCompetencesForPayload(
            competencyMode,
            selectedCompetences
          ),
        },
        () => {
          toast.success("Proceso de Selección creado exitosamente.", {
            duration: 4500,
          });
          setCreatedProcess(false)
          navigate(ROUTES.PROCESS.route);
        }
      );
    } else if (res.status ===400){
      toast.error('El número de invitados supera la cantidad de test disponibles, intenta quitando algunas personas de la lista.', {duration:6000})
      setCreatedProcess(false)
      setSteps(3)
    } else {
      setCreateProcess(false)
      toast.error('Ha ocurrido un error al crear el proceso, por favor, intente nuevamente.', {duration:4000})
    }
  });
};


useEffect(() => {
  const getSkills = async () => {
    const { data } = await listSkills();
    setListSkills(data);
    setFilteredSkills(
      data.filter((skill) => skill.colorType.includes("azul"))
    );
  };
  getSkills();
  //eslint-disable-next-line
}, []);

useEffect(() => {
  const chargeCreated = charges.filter((charges)=> charges.id === idCharge)
  if(chargeCreated.length !== 0){
    setSelectedCharge(chargeCreated[0])
  }
  //eslint-disable-next-line
}, [charges]);

useEffect(() => {
  getCharges();
  getCollaborators();
  //eslint-disable-next-line
}, []);

useEffect(() => {
  setFilteredCollaborators(
    collaborators.filter(
      (collab) =>
        collab.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        collab.email.toLowerCase().includes(searchTerm.toLocaleLowerCase())
    )
  );
}, [searchTerm, collaborators]);

useEffect(() => {
  const newAddedCollaborator = collaborators.find(
    (collaborators) => collaborators.rut === rutNewCollab
  );
  if (newAddedCollaborator)
    if (
      !selectedCollaborators.find(
        (selected) => selected.rut === newAddedCollaborator.rut
      )
    ) {
      setSelectedCollaborators((prevValues) => [
        ...prevValues,
        newAddedCollaborator,
      ]);
    }
  //eslint-disable-next-line
}, [collaborators]);

  return (
    <div className="gm-steps-creation-container">
      {open.errors && (
        <BulkLoadErrors
          open={open.errors}
          toggle={() => handleOpenModal("errors")}
          errorsModal={errorsModal}
        />
      )}

      {open.createCollab && (
        <CreateCollaboratorModal
          open={open.createCollab}
          toggle={() => handleOpenModal("createCollab")}
          clientId={user?.data?.clientId || ""}
          update={() => getCollaborators()}
          charge={charge?.name}
          setRutNewCollab={setRutNewCollab}
        />
      )}

      {open.bulk && (
        <BulkLoadModal
          handleOpenModal={() => handleOpenModal("errors")}
          setErrorsModal={setErrorsModal}
          open={open.bulk}
          toggle={() => handleOpenModal("bulk")}
          clientId={user?.data?.clientId || ""}
          update={() => getCollaborators()}
        />
      )}
      <Toaster />
      <section className="gm-modal-section-circle-steps">
        {stepProcessCreate.map((steps, index) => (
          <div className="gm-modal-section-step">
            <button
              onClick={() => {
                setSteps(index + 1);
              }}
              className={
                steps.step === stepsPass
                  ? "gm-modal-circle-active"
                  : "gm-modal-circles-section"
              }
              disabled={
                (!chargeCreated && steps.step === 3) ||
                (!chargeCreated && steps.step === 4)
              }
            >
              {steps.step}
            </button>
            <span>{steps.name}</span>
          </div>
        ))}
        <div className="gm-modal-line"></div>
      </section>
      <div className="gm-step-container">
        {stepsPass === 1 && (
          <>
            <span>¿Cuál es el nombre del cargo?</span>
            <input
              value={charge.name}
              onChange={(event) => handleChange("name", event.target.value)}
              maxLength={150}
              disabled={chargeCreated}
            />
            <div className="gm-container-info-charge">
              <section className="gm-section-competences-charge">
                <span>Descripción</span>
                <textarea
                  value={charge.description}
                  onChange={(event) =>
                    handleChange("description", event.target.value)
                  }
                  maxLength={2000}
                  disabled={chargeCreated}
                />
              </section>
            </div>
            <div className="gm-btn-action-selection">
              <button
                type="button"
                className="gm-secondary-button"
                onClick={() => handleCancelProcess()}
              >
                Cancelar
              </button>
              <ButtonLoading
                className="gm-primary-button"
                type="submit"
                buttonLabel="Continuar a competencias"
                onClick={() => {
                  setSteps(stepsPass + 1);
                }}
                // disabled={}
              />
            </div>
          </>
        )}
        {stepsPass === 2 && (
          <div className="gm-step-select-competences-view">
            <span>Seleccionar arquetipo </span>
            <select onChange={(event) => handleSelectColor(event)}>
              <option
                value="azul"
                style={{
                  color: "#8090E8",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Controlador
              </option>
              <option
                value="rojo"
                style={{
                  color: "#FF8080",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Dominante
              </option>
              <option
                value="amarillo"
                style={{
                  color: "#efd911",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Influyente
              </option>
              <option
                value="verde"
                style={{
                  color: "#80C6A7",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Sostenedor
              </option>
            </select>
            <div className="gm-selected-competences-section">
              <span>
              Escoge mínimo 3 y máximo 7 competencias asociadas a este cargo.{" "}
              </span>
              <p> Seleccionados {selectedSkills.length}/7</p>

              <section>
                {filteredSkills?.map((skills) => (
                  <button
                    className={
                      selectedSkills.find(
                        (selecteds) => selecteds.id === skills.id
                      )
                        ? `gm-buttons-selected--${selectedColor}`
                        : "gm-button-no-selected"
                    }
                    onClick={() => handleSelectSkill(skills)}
                    disabled={chargeCreated}
                    value={skills.id}
                  >
                    {" "}
                    {skills.name}{" "}
                    <span>
                      {" "}
                      {selectedSkills.find(
                        (selecteds) => selecteds.id === skills.id
                      ) ? (
                        <HiCheck size={16} />
                      ) : (
                        <HiPlus size={16} />
                      )}
                    </span>
                  </button>
                ))}
              </section>
            </div>
            <div className="gm-btn-action-selection">
              <button
                type="button"
                className="gm-secondary-button"
                onClick={() => handleCancelProcess()}
              >
                Cancelar
              </button>
              <ButtonLoading
                className="gm-primary-button"
                type="submit"
                buttonLabel="Continuar"
                onClick={() => {
                  chargeCreated
                    ? setSteps(stepsPass + 1)
                    : handleCreateCharge();
                }}
                disabled={
                  charge.name === "" ||
                  charge.description === "" ||
                  selectedSkills.length < 3 ||
                  selectedSkills.length > 7
                }
                loading={chargeResolver.loading}
              />
            </div>
          </div>
        )}
        {stepsPass === 3 && (
          <>
            <div className="gm-step-container">
              <span>Evaluación</span>
              <select onChange={(e) => handleSelect("test", e)}>
                <option>Seleccionar Evaluación</option>
                {testData?.map((test) => (
                  <option value={test}>{test}</option>
                ))}
              </select>
              <div className="gm-selection-add-collab">
                <p
                >
                </p>
                <p>
                ¿Necesitas más test? Escríbenos a <span>{CONTACT_EMAIL}</span>
                </p>
              </div>
              <CompetencyModeSelector
                mode={competencyMode}
                onModeChange={setCompetencyMode}
                selected={selectedCompetences}
                onSelectedChange={setSelectedCompetences}
              />
              <span>¿Quiénes pueden hacer esta evaluación?</span>
              <div
                className="gm-selection-searchbar-collab"
                onFocus={() => setShowCollaborators(true)}
                onBlur={handleBlur}
                tabIndex={-1}
              >
                <input
                  onClick={() => setShowCollaborators(true)}
                  type="text"
                  placeholder="Buscar por nombre o correo"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                />
                {showCollaborators && (
                  <ul>
                    <li>
                      <div>
                        <span>
                          Seleccionar los Colaboradores (
                          {selectedCollaborators.length})
                        </span>
                        <span></span>
                      </div>
                      <div>
                        Seleccionar todos
                        <input
                          type="checkbox"
                          onChange={handleSelectAllCollaborators}
                          checked={
                            collaborators.length > 0 &&
                            selectedCollaborators.length ===
                              collaborators.length
                          }
                        />
                      </div>
                    </li>
                    {filteredCollaborators.map((collab, index) => (
                      <li key={index}>
                        <div>
                          <span>{`${collab.name} ${collab.surname}`}</span>
                          <span>{collab.email}</span>
                        </div>
                        <div>
                          {collab.collaboratorInternal ? "Interno" : "Externo"}
                          <input
                            type="checkbox"
                            checked={selectedCollaborators.some(
                              (selected) => selected.id === collab.id
                            )}
                            onChange={() => handleSelectCollaborator(collab.id)}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="gm-selection-add-collab">
                <button
                  type="button"
                  onClick={() => handleOpenModal("createCollab")}
                >
                  <HiOutlinePlusCircle /> Nuevo Colaborador
                </button>
                <button type="button" onClick={() => handleOpenModal("bulk")}>
                  <HiOutlineCloudUpload /> Creación con Carga Masiva
                </button>
              </div>
              {selectedCollaborators.length !== 0 && (
                <ul>
                  {selectedCollaborators.map((collab) => (
                    <li>
                      <div>
                        <span> {`${collab.name} ${collab.surname}`} </span>
                        <span> {collab.email}</span>
                      </div>
                      <div>
                        {" "}
                        {collab.collaboratorInternal
                          ? "Interno"
                          : "Externo"}{" "}
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => {
                            handleDeleteCollaborator(collab.id);
                          }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              )}{" "}
              <div className="gm-btn-action-selection">
                <button
                  type="button"
                  className="gm-secondary-button"
                  onClick={() => handleCancelProcess()}
                >
                  Cancelar
                </button>
                <ButtonLoading
                  className="gm-primary-button"
                  type="submit"
                  buttonLabel="Continuar"
                  onClick={() => {
                    setSteps(stepsPass + 1);
                    setCreateProcess(true);
                  }}
                  disabled={
                    selectedCollaborators.length === 0 ||
                    selectedTest.length === 0 ||
                    !isCompetencySelectionValid(competencyMode, selectedCompetences)
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
      {stepsPass === 4 && (
        <div className="gm-step-container-preview">
          <InfoCharge charge={selectedCharge} />
          <div style={{ height: "35px" }}></div>
          <div>
            <div className="gm-ts-searchbar-container">
              <div className="gm-ts-searchbar-title-container"></div>
              <div className="gm-ts-searchbar-actions-container">
                <form onSubmit={(e) => handleSearchByName(e, "name")}>
                  <InputIcon
                    Icon={HiMagnifyingGlass}
                    type="text"
                    placeholder="Buscar por nombre"
                    name="search"
                    value={searchValues.name}
                    onChange={(e) => handleChangeValue("name", e.target.value)}
                  />
                </form>
                <form>
                  <div className="gm-input-icon-container">
                    <select
                      name="origen"
                      onChange={(event) => {
                        handleChangeOrigin(event);
                      }}
                    >
                      <option value={false}>Filtrar por origen</option>
                      <option value="collaboratorInternal">Interno</option>
                      <option value="collaboratorExternal">Externo </option>
                    </select>
                  </div>
                </form>
                {searchExists && (
                  <button
                    className="gm-clean-search-button"
                    onClick={handleCleanSearch}
                    type="button"
                  >
                    <AiOutlineClose size={18} />
                  </button>
                )}
              </div>
            </div>
          </div>
          <TableComponent
            header="primary-green"
            columns={columns}
            data={
              isFiltered
                ? filteredTableCollaborators
                : selectedCollaborators || []
            }
            loading={updatedCollaborators}
          />
          <footer>
            <button
              type="button"
              className="gm-secondary-button"
              onClick={() => handleCancelProcess()}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Crear Proceso"
              onClick={() => {
                handleSubmit();
              }}
              disabled={
                selectedCharge.length === 0 || selectedTest.length === 0 ||
                !isCompetencySelectionValid(competencyMode, selectedCompetences)
              }
              loading={createdProcess}
            />
          </footer>
        </div>
      )}
    </div>
  );
};

export default CreateProcessSelectionAndCharge;
